import axios from 'axios'
const { VUE_APP_API_URL } = process.env

const loginStaff = async (logname, password) => {
  try {
    const apiURL = VUE_APP_API_URL
    const res = await axios
      .post(`${apiURL}/cons-bio/consultant/login`, {
        logname,
        password
      })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const uploadConsultantImage = async (data) => {
  try {
    const apiURL = VUE_APP_API_URL
    const res = await axios
      .post(`${apiURL}/cons-bio/consultant/upload`, data)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

export {
  loginStaff, uploadConsultantImage
}
